import React from 'react';
import FormLogin from './FormLogin';

const Login = () => {
    return (
        <main className='main__login'>
            <FormLogin />
        </main>
    );
};

export default Login;
